// extracted by mini-css-extract-plugin
export default {"Header":"ProductHeader_Header__HEVin"};